<template>
  <view class="content">
    <view class="card">
      <text class="text">功能建设中</text>
    </view>
    <BottomTabBar active="mine" />
  </view>
</template>

<script>
import BottomTabBar from '@/components/BottomTabBar.vue'
export default {
  name: 'Report',
  components: { BottomTabBar }
}
</script>

<style scoped>
.content { width: 100%; min-height: 100vh; background-color: #f5f7fa; padding-bottom: 120rpx; }
.navbar { display: flex; align-items: center; justify-content: space-between; padding: 0 30rpx; height: 88rpx; background: linear-gradient(90deg, #1E88E5, #26A69A); color: #fff; }
.navbar-title { font-size: 36rpx; font-weight: 600; }
.card { background-color: #fff; margin: 20rpx; border-radius: 16rpx; padding: 24rpx; box-shadow: 0 2rpx 10rpx rgba(0,0,0,0.05); }
.text { font-size: 28rpx; color: #666; }
</style>

